import {Model} from 'backbone';

class CarPart extends Model.extend({
  idAttribute: 'carPartId'
}) {}

export default CarPart;
